import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const MuteIcon = createIcon({
  displayName: 'MuteIcon',
  path: [
    <path
      d='M7.5 8.75H11.5L17.25 4.75V15.5M17.25 19.25L11.5 15.25H7.75C7.19772 15.25 6.75 14.8023 6.75 14.25V11.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M19.25 17.25L4.75 6.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
